import { render, staticRenderFns } from "./ContentCenter.vue?vue&type=template&id=3476fa9c"
import script from "./ContentCenter.vue?vue&type=script&lang=js"
export * from "./ContentCenter.vue?vue&type=script&lang=js"
import style0 from "./ContentCenter.vue?vue&type=style&index=0&id=3476fa9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports